import { formatDistance } from 'date-fns'

export const formatTimePassed = (timestamp) => {
  console.log(timestamp)
  console.log(new Date(timestamp))
  console.log(formatDistance(new Date(timestamp), new Date()))
  return formatDistance(new Date(timestamp), new Date())

}